import { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  getIntercomAppIdForPathname,
  switchIntercomWorkspace,
  shutdownIntercom,
} from './intercom';

const IntercomRouteSync: FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const controller = new AbortController();
    const appId = getIntercomAppIdForPathname(pathname);

    switchIntercomWorkspace(appId, controller.signal).catch(() => {
      /* script load failure or aborted — non-critical */
    });

    return () => {
      controller.abort();
    };
  }, [pathname]);

  useEffect(() => () => {
    shutdownIntercom();
  }, []);

  return null;
};

export default IntercomRouteSync;
